/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {BaseInstance} from './base-instance';
import {DriverObject} from './driver-object';

export class DriverObjectInstance extends BaseInstance {
  driverObject: DriverObject;
}
